import { connect } from 'react-redux'
import Logo from './Logo'

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(
  mapStateToProps
)(Logo)



// WEBPACK FOOTER //
// ./src/components/Layout/Logo/index.js